<template>
	<div class="all margin-left">
		<div class="text-df text-999 text-left"><span class="text-df text-333">选择提现银行卡</span> 没有添加银行卡，可以 <span
				class="text-df pointer text-theme" @click="godetail('addbank')">添加银行卡</span></div>
		<div class="margin-top-sm">
			<el-collapse accordion>
				<el-collapse-item>
					<template slot="title">
			 		<div class="flex align-center bank">
							<img class="block-34" src="../../../assets/img/wallet/t-bank.png">
							<p class="text-df text-333 margin-left-xs">{{shoeitem&&shoeitem.bank}}</p>
						</div>
					</template>
					<div class="flex align-center bank justify-between pointer" @click="chobank(item,index)"
						v-for="(item,index) in lists" :key="index">
			  	<div class="flex align-center">
							<img class="block-34" src="../../../assets/img/wallet/t-bank.png">
							<p class="text-df text-333 margin-left-xs">{{item.bank}}</p>
						</div>
						<img v-if="choseindex == index" class="block-50" src="../../../assets/img/chek.png" alt="">
						<img v-else class="block-50" src="../../../assets/img/nochek.png" alt="">
						<!-- <img class="block-50" :src="choseindex == index?'../../../assets/img/chek.png':'../../../assets/img/nochek.png'" alt=""> -->
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
		<div class="entry margin-top-sm">
			<div class="flex align-center height100 solid-bottom">
				<p class="text-df">请输入提现金额</p>
				<div class="flex align-center margin-left-sm">
					<p class="fs36">￥</p>
					<input class="fs36 entmoney" type="number" placeholder="请输入" v-model="money" value=""
						@input="checkmoney" />
				</div>
			</div>
			<div class="flex align-center justify-between height100">
				<p class="text-df">当前可提现金额 <span class="text-theme text-bold">{{price}}</span> 元</p>
				<div class="btns text-theme pointer" @click="money = price">全部提现</div>
			</div>
		</div>
		<div class="password flex align-center padding-lr margin-top-sm">
			<p class="text-df">提现密码</p>
			<input class="text-df text-ccc margin-left-xs" type="number" placeholder="请输入提现密码" v-model="pass"
				value="" />
		</div>
		<div class="flex flex-direction justify-center align-center">
			<div class="tx-btn text-white pointer" @click="subtn">立即提现</div>
			<div>申请提现成功 3个工作日后到账</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				lists: [],
				pass: '',
				money: '',
				choseindex: 0,
				shoeitem: null,
				price: 0,
				isset: false
			};
		},
		created() {
			this.getMyMoney()
			this.getlist()
		},
		destroyed() {

		},
		methods: {
			//通知center 跳转对应页面
			godetail(index) {
				let type = {
					type: index,
					typeone: 'wallet'
				}
				this.$emit('gettype', type)
			},
			/**
			 * 判断是否有提现密码
			 * */
			getisPricePwd() {
				this.ajax('get', '/api/user/isPricePwd', {

				}, res => {
					if (res.data.code == 250) {
						this.isset = false
					} else {
						this.isset = true
					}
				})
			},
			//获取我得余额
			getMyMoney() {
				this.ajax('get', '/api/pc/priceLog/getMyPrice', {

				}, res => {
					if (res.status == 200) {
						this.price = res.data.price
					} else {
						this.$message(res.msg);
					}
				})
			},
			//获取我得银行卡
			getlist() {
				this.ajax('get', '/api/userBank/getBankList', {
					page: 1
				}, res => {
					console.log(res);
					if (res.status == 200) {
						this.lists = res.data.data
						this.shoeitem = res.data.data[0]
					} else {
						this.$message(res.msg);
					}
				})
			},
			//选择银行卡
			chobank(item, index) {
				this.choseindex = index
				this.shoeitem = this.lists[index]
			},
			//判断输入得金额大小
			checkmoney() {
				if (this.money > this.price) {
					this.money = this.price
					this.$message('可提现金额不足');
				}
			},
			subtn() {
				if(!this.isset){
					 this.$message('请先设置提现密码')
					 setTimeout(()=>{
						 this.godetail('setpass')
					 },500)
					return;
				}
				if (this.lists.length == 0) {
					return this.$message('请先绑定银行卡');
				}
				if (!this.money) {
					return this.$message('请输入提现金额');
				}
				if (!this.pass) {
					return this.$message('请输入提现密码');
				}

				this.ajax('post', '/api/withdrawal/add', {
					bank_id: this.shoeitem.id,
					price: this.money,
					price_pwd: this.pass
				}, res => {
					console.log(res);
					if (res.status == 200) {
						if (res.data.code == 210) {
							return this.$message(res.data.msg);
						}
						this.$message(res.msg)

					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all {
		width: 920px;
	}

	.fs28 {
		font-size: 28px;
	}

	.fs36 {
		font-size: 36px;
	}

	.block-34 {
		width: 34px;
		height: 34px;
	}

	.block-50 {
		width: 20px;
		height: 20px;
	}

	.el-collapse {
		width: 920px;
		background: #FFFFFF;
		padding: 0 30px;
		border: 0;
	}

	/deep/ .el-collapse-item__header {
		height: 80px;
	}

	.bank {
		height: 80px;
		background: #FFFFFF;
	}

	.height100 {
		height: 100px;
	}

	.entry {
		width: 920px;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 0 30px;

		.entmoney {}

		.btns {
			width: 106px;
			height: 35px;
			line-height: 35px;
			background: rgba(9, 130, 123, 0.2);
			border: 1px solid #09827B;
			border-radius: 18px;
		}
	}

	.password {
		width: 461px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 8px;
	}

	.tx-btn {
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2);
		border-radius: 30px;
		margin-top: 115px;
		margin-bottom: 30px;
	}

	input {
		border: 0;
		outline: 0;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/withdraw.vue